import PropTypes from 'prop-types';
import { StyledButton } from './buttonStyled';

export default function CustomizedButtons({title,type,handleClick}) {
  return (
      <StyledButton variant="contained" type={type} onClick={handleClick}  className='btn'>
        {title}
      </StyledButton>
  );
}

CustomizedButtons.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  };